import React from 'react';
import Card from '../../../components/layouts/card/card';
import FontBody1 from '../../../components/fonts/font-body1/font-body1';
import { FONT_COLOR, FONT_VARIANT } from '../../../components/fonts/font-props';
import Icon from '../../../components/icons/icon/icon';
import {IconCoverage} from '../../../components/icons/icon-coverage/icon-coverage';
import FontHeading1 from '../../../components/fonts/font-heading1/font-heading1';
import "./coverage-book-a-meeting-page.scss";
import useDashboardTranslation from '../../../dashboard-translation/hooks/dashboard-translation-hook';
import { observer } from 'mobx-react-lite';
import coverageSettingsStore from "../stores/coverage-settings-store";
import ScriptLoader from "../../../services/Utilities/script-loader";
import { ICON_SIZE } from '../../../components/icons/icon-props-interface';
import { Button } from '../../../components/inputs/button/button';
import { BUTTON_VARIANTS } from '../../../components/inputs/button-variants';



const CoverageBookAMeetingPage: React.FC = observer(() => {

    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-coverage-settings';

    const store = coverageSettingsStore;
    
    const hubspotScriptUrl = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
    ScriptLoader.loadScript(hubspotScriptUrl);
    
    return (
        <Card>
            <div className="book-a-meeting-header">
                <div className="book-a-meeting-header-title">
                    <FontHeading1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD} >{getTranslation('BOOK_A_MEETING_TITLE', scope)}</FontHeading1>
                    <Icon Component={IconCoverage} size={ICON_SIZE.MEDIUM}/>
                </div>
                <FontBody1 color={FONT_COLOR.PRIMARY2}>{getTranslation('BOOK_A_MEETING_SUBTITLE', scope)}</FontBody1>
            </div>
            <div
                className="meetings-iframe-container"
                data-src="https://meetings.hubspot.com/returngo/onboarding-session?embed=true"
            ></div>
            
            <div className='book-a-meeting-footer'>
                <Button variant={BUTTON_VARIANTS.Secondary} text={getTranslation('BOOK_A_MEETING_LINK', scope)} onClick={()=> store.onShowCoverageSettingsPageClick()} />
            </div>

        </Card>
    );
});

export default CoverageBookAMeetingPage;